<script setup lang="ts">
import type { ComponentBrandNewsProps } from "./ComponentBrandNews.props"
const props = defineProps<ComponentBrandNewsProps>()
</script>

<template>
  <div class="cms-brand-news py-10">
    <ProductBlocksBrandsNewsCategoryBlock v-if="props" v-bind="props" />
  </div>
</template>
